module.exports = __webpack_public_path__ + "static/media/D10.29d7dba6.png";